import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useDate } from "@/hooks/use-date/useDate";
import { Icon } from "@/components/icons/Icon";
import { type InspectionData } from "../inspection.d";
import { useDevice } from "@/store/useDevice";

interface ClosedInspectionInfoProps {
  data: InspectionData;
}

const ClosedInspectionInfo = ({ data }: ClosedInspectionInfoProps) => {
  const translate = useTranslate();
  const { isMobile } = useDevice();
  const { formatDate, getTotalDays } = useDate();

  return (
    <div className="w-full border-b border-b-ib-gray-lightest bg-ib-gray-lightest-2 flex flex-col md:flex-row md:items-center px-4 md:px-14 gap-2 md:gap-6 py-2">
      <div className="text-ib-main flex flex-row items-center ">
        <Icon
          name="checkedFolder"
          className="size-4 text-ib-gray-dark-2 mr-1"
        />
        <p className="text-ib-gray-main">{translate("inspectionCompleted")}</p>
      </div>
      <div className="flex items-center gap-4">
        <Detail
          label={translate(isMobile ? "start" : "startDate")}
          value={formatDate(data.createdAt)}
        />
        <Detail
          label={translate(isMobile ? "end" : "endDate")}
          value={formatDate(data.endDate)}
        />
      </div>
      <Detail
        label={translate("inspectionDuration")}
        value={getTotalDays(data.createdAt, data.endDate)}
      />
    </div>
  );
};

export default ClosedInspectionInfo;

const Detail = ({ label, value }: { label: string; value: string }) => (
  <p className="flex gap-1 items-center text-ib-main ">
    <span className="text-ib-gray-main">{label}: </span>
    <span className="font-ib-bold text-ib-gray-darkest">{value}</span>
  </p>
);
